/**
 * Self-contained launcher-bundle entry for NON-React host surfaces (Story 4.5,
 * AC 1) — primarily the Freshdesk customer portal, which is not a SkillsPass
 * React app and therefore cannot `import`/render `<AskLauncher/>` as JSX.
 *
 * Built by `freshdesk-launcher.tsup.config.ts` into a single browser IIFE
 * (`dist/launcher.global.js`) that bundles the REAL `@bln/embed` launcher + its
 * React peers IN (so the portal loads ONE self-contained script — no import map,
 * no peer resolution in the portal), and exposes exactly one imperative entry
 * point on `window.blnSupportBot`:
 *
 *   window.blnSupportBot.mountAskLauncher(el, {
 *     widgetUrl, tenant, locale?, anonUserId?, placement?, zIndex?,
 *   }): () => void   // returns a teardown that unmounts the launcher;
 *                    // the teardown also carries `.setLocale(locale)` (REQ-028)
 *
 *   window.blnSupportBot.followKbLocale(kbIframe, {
 *     kbOrigin, languages, locale, onChange,
 *   }): () => void   // the support wrapper's listener for the framed KB's language
 *
 * The head/layout snippet (`freshdesk-portal-head.html`) loads this bundle and
 * calls `mountAskLauncher`. This bundle is served SAME-ORIGIN under the same
 * `/support-bot` Traefik route as the widget iframe (see
 * docs/deployment/multi-surface-injection.md → "Serving"). No secrets are baked
 * in — all per-visitor values are passed at call time by the portal snippet.
 */
import {
  followKbLocale,
  mountAskLauncher,
} from '@bluedrop-learning-networks/bln-support-bot-embed';

declare global {
  interface Window {
    blnSupportBot?: {
      mountAskLauncher: typeof mountAskLauncher;
      followKbLocale: typeof followKbLocale;
    };
  }
}

window.blnSupportBot = { mountAskLauncher, followKbLocale };
